import type { ReactNode } from "react";

export const AERA_FIELD_LABEL_BASE_CLASS = "block text-aera-charcoal";

export const AERA_FIELD_LABEL_SIZE_CLASS = {
  default: "text-base font-semibold",
  "2xl": "text-2xl font-bold",
} as const;

export type AeraFieldLabelSize = keyof typeof AERA_FIELD_LABEL_SIZE_CLASS;

export const AERA_FIELD_LABEL_CLASS = [
  AERA_FIELD_LABEL_BASE_CLASS,
  AERA_FIELD_LABEL_SIZE_CLASS.default,
].join(" ");

type AeraFieldLabelBaseProps = {
  children: ReactNode;
  className?: string;
  size?: AeraFieldLabelSize;
};

type AeraFieldLabelAsP = AeraFieldLabelBaseProps & {
  as?: "p";
};

type AeraFieldLabelAsLabel = AeraFieldLabelBaseProps & {
  as: "label";
  htmlFor?: string;
};

export type AeraFieldLabelProps = AeraFieldLabelAsP | AeraFieldLabelAsLabel;

export function AeraFieldLabel(props: AeraFieldLabelProps) {
  const { size = "default" } = props;
  const className = [
    AERA_FIELD_LABEL_BASE_CLASS,
    AERA_FIELD_LABEL_SIZE_CLASS[size],
    props.className,
  ]
    .filter(Boolean)
    .join(" ");

  if (props.as === "label") {
    return (
      <label htmlFor={props.htmlFor} className={className}>
        {props.children}
      </label>
    );
  }

  return <p className={className}>{props.children}</p>;
}
